import { FiWind } from "react-icons/fi";
import { Button } from "../../../components/Buttons";
import { AppPathsClient } from "../../../routes/AppRoutes";

export const ScheduleEmptyState: React.FC = () => {
    return (
        <div className="p-6 flex flex-col items-center justify-center h-full-minus-header text-center">
            <FiWind className="w-12 h-12 mb-4 text-gray-600 -mt-20" />
            <h1 className="text-2xl font-medium text-gray-700 mb-2">No active program</h1>
            <p className="mb-6">You currently do not have an active program assigned to you.</p>
            <div>
                <Button link={AppPathsClient.dashboard}>View dashboard</Button>
            </div>
        </div>
    );
}